import { AppRouteProps } from "@harea/component";
import React from "react";

const SyndicalCotisationListContainer = React.lazy(() =>
    import("./container/SyndicalCotisationListContainer"),
);

export const CotisationSyndicaleRoutes = [
    {
        path: "cotisation-syndicale",
        element: <SyndicalCotisationListContainer />,
        title: "Harea.Payroll.SyndicalCotisation.Title",
    },
] as Array<AppRouteProps>;